
const styles = (theme) => ({
    card: {
		maxWidth: 600,
		marginTop:20
	},
	media: {
		height: 0,
		paddingTop: '80%',
		marginTop:'30'
	},
});

export default styles;
